export default function Progressbar({ activePart, handleStep }) {
    return (
        <div className="my-12 mx-0">
            <div className="flex border-b border-solid border-gray-400 -m-3 mx-9">

            </div>
            <div className="flex justify-between">
                <div className="flex flex-col items-center">
                    <div className="flex">
                        <div className="bg-white w-10 h-5"></div>
                        <div className={`${activePart === 0 ? "bg-yellow-500" : "bg-white"} rounded-full border border-solid border-yellow-500 w-5 h-5`}></div>
                        <div className="w-10 h-5"></div>
                    </div>
                    <div className="cursor-pointer" onClick={() => handleStep(0)}>
                        اطلاعات پایه شغل
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex">
                        <div className=" w-10 h-5"></div>
                        <div className={`${activePart === 1 ? "bg-yellow-500" : "bg-white"} rounded-full border border-solid border-yellow-500 w-5 h-5`}></div>
                        <div className="w-10 h-5"></div>
                    </div>
                    <div className="cursor-pointer" onClick={() => handleStep(1)}>
                        ویژگی‌های شغل
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex">
                        <div className="w-10 h-5"></div>
                        <div className={`${activePart === 2 ? "bg-yellow-500" : "bg-white"} rounded-full border border-solid border-yellow-500 w-5 h-5`}></div>
                        <div className="w-10 h-5"></div>
                    </div>
                    <div className="cursor-pointer" onClick={() => handleStep(2)}>
                        شرایط احراز شغل
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex">
                        <div className="w-10 h-5"></div>
                        <div className={`${activePart === 3 ? "bg-yellow-500" : "bg-white"} rounded-full border border-solid border-yellow-500 w-5 h-5`}></div>
                        <div className="w-10 h-5"></div>
                    </div>
                    <div className="cursor-pointer" onClick={() => handleStep(3)}>
                        مهارت‌های پایه‌ای شغل
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex">
                        <div className="w-10 h-5"></div>
                        <div className={`${activePart === 4 ? "bg-yellow-500" : "bg-white"} rounded-full border border-solid border-yellow-500 w-5 h-5`}></div>
                        <div className="w-10 h-5"></div>
                    </div>
                    <div className="cursor-pointer" onClick={() => handleStep(4)}>
                        شایستگی‌های شغل
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex">
                        <div className="w-10 h-5"></div>
                        <div className={`${activePart === 5 ? "bg-yellow-500" : "bg-white"} rounded-full border border-solid border-yellow-500 w-5 h-5`}></div>
                        <div className="w-10 h-5"></div>
                    </div>
                    <div className="cursor-pointer" onClick={() => handleStep(5)}>
                        گریدینگ شغل
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex">
                        <div className="w-10 h-5"></div>
                        <div className={`${activePart === 6 ? "bg-yellow-500" : "bg-white"} rounded-full border border-solid border-yellow-500 w-5 h-5`}></div>
                        <div className="w-10 h-5"></div>
                    </div>
                    <div className="cursor-pointer" onClick={() => handleStep(6)}>
                        شاخص‌های ارزیابی عملکرد
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex">
                        <div className="w-10 h-5"></div>
                        <div className={`${activePart === 7 ? "bg-yellow-500" : "bg-white"} rounded-full border border-solid border-yellow-500 w-5 h-5`}></div>
                        <div className="bg-white w-10 h-5"></div>
                    </div>
                    <div className="cursor-pointer" onClick={() => handleStep(7)}>
                        ویژگی‌های روانشناسی شغل
                    </div>
                </div>
            </div>
        </div>
    )
}